<template>
    <Drawer
        :title="title"
        v-model="isBox"
        width="980"
        :mask-closable="false"
        @on-close="FormReset()"
        class-name="drawer-default"
    >
        <div class="set-scroll-form">
            <Form ref="Forms" :model="Forms" :rules="Rules" label-position="top">
                <Row :gutter="32">
                    <Col span="12">
                        <FormItem label="角色名称：" prop="name">
                            <Input v-model="Forms.name" placeholder="角色名称" />
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="角色状态：">
                            <RadioGroup v-model="Forms.status" type="button">
                                <Radio :label="1">审核</Radio>
                                <Radio :label="2">禁用</Radio>
                                <Radio :label="3">开启</Radio>
                            </RadioGroup>
                        </FormItem>
                    </Col>
                </Row>
                <Divider orientation="left" :dashed="true">角色权限</Divider>
                <Row>
                    <Col span="24"  v-for="(item,index) in Forms.authority" :key="index">
                        <Checkbox
                            :indeterminate="item.indeterminate"
                            v-model="item.selected"
                            @on-change="checkRouter(index, $event)" class="auth-checkbox text-primary"><strong class="text-primary">{{item.title}}</strong></Checkbox>
                        <Col span="24" class="auth-checkbox-line" v-if="item.children">
                            <Checkbox v-model="items.selected" :label="items.id" v-for="(items,indexs) in item.children" :key="indexs" @on-change="checkRouterChildren(index, items.id, $event)">{{items.title}}</Checkbox>
                        </Col>
                    </Col>
                </Row>
            </Form>
            <div class="box-drawer-footer">
                <Button style="margin-right: 8px" @click="FormReset()">取消</Button>
                <Button type="primary" :loading="$store.state.loading" @click="FormSubmit()">保存</Button>
            </div>
        </div>
    </Drawer>
</template>

<script>

import {getAllRouterList} from "@/apis/auth";
import {saveGroup, getGroupDetail} from "@/apis/group";

export default {
    name: 'Create',
    components: {
    },
    emits: ['trueHandler'],
    data () {
        return {
            title : '新增角色',
            isBox : false,
            parentList : [],
            Forms : {
                group_id:'',
                name: '',
                status: 3,
                authority: []
            },
            Rules : {
                name: [
                    { required: true, message: '请输入角色名称', trigger: 'blur' }
                ]
            }
        }
    },
    methods: {
        /**
         功能：全选/全不选
         time: 2025-31-02 16:31:32
         **/
        checkRouter(index, e){
            this.Forms.authority[index].indeterminate = false;
            this.Forms.authority[index].selected = e;
            var childrenArray = this.Forms.authority[index].children
            if(childrenArray){
                for(var i=0,len=childrenArray.length; i<len; i++){
                    childrenArray[i].selected = e
                }
            }
        },
        /**
         功能：点击子路由
         time: 2025-31-02 16:31:58
         **/
        checkRouterChildren(index, childId, e){
            var childrenArray = this.Forms.authority[index].children
            var unTickCount = 0, len = childrenArray.length
            for(var i = 0; i < len; i++){
                if(childId === childrenArray[i].id) childrenArray[i].selected = e
                if(childrenArray[i].selected === false) unTickCount++
            }

            if(unTickCount === len) {//三级级全不勾选
                this.Forms.authority[index].indeterminate = false;
                this.Forms.authority[index].selected = false;
            }else if(unTickCount > 0 && unTickCount < len){
                this.Forms.authority[index].indeterminate = true;
                this.Forms.authority[index].selected = false;
            } else {
                this.Forms.authority[index].indeterminate = false;
                this.Forms.authority[index].selected = true
            }
        },
        /**
         功能：获取全部路由
         time: 2025-35-02 09:35:02
         **/
        GetRouterList(){
            let that = this;
            getAllRouterList().then(e=>{
                that.Forms.authority = e.data;
            })
        },
        /**
         功能：获取详情
         time: 2025-53-02 10:53:04
         **/
        GetDetail(group_id){
            let that = this;
            that.$store.commit('SET_LOADING' , true);
            getGroupDetail(group_id).then(e => {
                let data = e.data;
                for (let v of Object.keys(that.Forms)) {
                    that.Forms[v] = data[v];
                }
            })
        },
        /**
         功能：添加
         time: 2025-52-02 10:52:34
         **/
        add(){
            this.isBox = true;
            this.GetRouterList();
        },
        /**
         功能：编辑
         time: 2025-52-02 10:52:42
         **/
        edit(group_id){
            this.isBox = true;
            this.title = '编辑角色';
            if(group_id) this.GetDetail(group_id);
        },
        /**
         功能：
         time: 2025-55-02 10:55:40
         **/
        FormSubmit(){
            let that = this;
            this.$refs['Forms'].validate((valid) => {
                if (valid) {
                    that.$store.commit('SET_LOADING' , true);
                    saveGroup(that.Forms).then( e =>{
                        that.$Message.success({ background: true,duration:3, content: e.msg });
                        that.FormReset();
                        that.$emit('trueHandler');
                    })
                }
            })
        },
        /**
         功能：
         time: 2025-55-02 10:55:45
         **/
        FormReset(){
            this.isBox = false;
            this.title = '新增角色';
            this.$refs['Forms'].resetFields();
            this.Forms.group_id = '';
            this.Forms.authority = [];
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less" rel="stylesheet/less">
.forms {
    .ivu-form-item {
        //margin-bottom: 0 !important;
    }
}
.spin-icon-load{
    animation: ani-demo-spin 1s linear infinite;
}
@keyframes ani-demo-spin {
    from { transform: rotate(0deg);}
    50%  { transform: rotate(180deg);}
    to   { transform: rotate(360deg);}
}
.spin-text {
    font-size: 12px;
    padding-top: 10px;
}
</style>
